module.exports = __webpack_public_path__ + "img/logo_b2c.b9c2670b.png";